module.exports = __webpack_public_path__ + "static/media/small_custom_pens.c47c5096.jpg";